export enum EmploymentStatus {    
    Employed = 4,
    Homemaker = 5,
    Retired = 6,
    Student = 7,
    Unemployed = 1,
    Other = 8
}